import { render, staticRenderFns } from "./environment-banner.vue?vue&type=template&id=165436e1"
import script from "./environment-banner.vue?vue&type=script&lang=js"
export * from "./environment-banner.vue?vue&type=script&lang=js"
import style0 from "./environment-banner.vue?vue&type=style&index=0&id=165436e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports